export const FormInput = ({ name, value, onChange, placeholder, error }) => (
  <div className="mb-4">
    <input
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="w-full border border-black/60 rounded-none px-4 py-3 outline-none focus:border-black"
    />
    {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
  </div>
);